import {Grid} from '../../../../design-system/atoms/Grid/Grid';
import {CommonGroupProps} from '../../type';

function SubCard({children}: CommonGroupProps) {
  return (
    <Grid cols={3} gapPx={3}>
      {children}
    </Grid>
  );
}

export default SubCard;
